import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@radix-ui/react-dropdown-menu";
import PlusIcon from "app/components/Icons/PlusIcon";
import IconText from "app/components/IconText";
import { BOARD_TEMP_OPTIONS } from "app/data";
import { selectIsBoardCreate } from "app/redux/selector";
import { actions } from "app/redux/slice";
import { BoardTemplateEnum } from "app/types";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { actions as actionsBoardSetting } from "./Settings/redux/slice";
import { useBoardsActions } from "./useBoardsActions";
import { Board } from "../types";
export default function AddBoard({ visibleBoard, hiddenBoard }) {
  const params = useParams();
  const { project, team } = params;
  const navigate = useNavigate();
  const first2Options = BOARD_TEMP_OPTIONS.slice(0, 2);
  const remainingOptions = BOARD_TEMP_OPTIONS.slice(2);
  const dispatch = useDispatch();
  const isLoading = useSelector(selectIsBoardCreate);
  const { fetchBoardDetails, toggleBoardSetting } = useBoardsActions(
    params.project as string,
  );

  const handleCreate = (type: BoardTemplateEnum) => {
    dispatch(
      actions.doCreateFixTempBoard({
        data: {
          projectId: project as string,
          teamId: team as string,
          templateType: type,
          visibleBoard: visibleBoard,
        },
        callback(data: Board) {
          navigate(
            `/app/${project}/${team}/boards/${data._id}/${data.viewType}/board`,
          );
          dispatch(
            actions.updateNewBoardOrderState({
              board: data,
              visibleBoard: visibleBoard + 1,
            }),
          );
          toggleBoardSetting(true);
          fetchBoardDetails(data._id);
        },
      }),
    );
    if (type === BoardTemplateEnum.KANBAN || type === BoardTemplateEnum.LIST) {
      navigate(
        `/app/${project}/${team}/boards/${
          params.boardId
        }/${type?.toLowerCase()}/board`,
      );
      toggleBoardSetting(true);
      dispatch(actionsBoardSetting.setClearDraftFrom());
      dispatch(actionsBoardSetting.setClearBoardForm());
      dispatch(actionsBoardSetting.setBoardLoading(true));
    }
  };

  const renderOptions = (option) => {
    return (
      <DropdownMenuItem
        key={option.type}
        className="flex flex-row gap-[6px] p-[8px] focus:outline-none hover:bg-[#F4F5F7] rounded-[4px] cursor-pointer"
        onClick={() => {
          handleCreate(option.type as BoardTemplateEnum);
        }}
        disabled={isLoading}
      >
        <img
          className="size-[40px] min-w-[40px]"
          src={option.img}
          alt={option.title}
        />
        <div className="flex flex-col">
          <p className="text-black text-sm leading-[21px] font-medium">
            {option.title}
          </p>
          <p className="text-secondary text-xs leading-[18px] font-normal">
            {option.caption}
          </p>
        </div>
      </DropdownMenuItem>
    );
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Link
          to="#"
          className={`hover:bg-gray-100 py-2 px-[10px] rounded-[4px] focus:outline-none`}
        >
          <IconText
            className="gap-[6px]"
            text="View"
            textClassName="text-secondary text-sm leading-[21px] font-normal"
            icon={<PlusIcon size={20} />}
          />
        </Link>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="start"
        className="z-40  p-4 py-[26px] !w-[594px] bg-danger gap-[10px] !bg-white rounded-[4px] shadow-[2px_2px_6px_0px_rgba(237,239,242,0.70)] border border-[#E9ECF2]" // move to the right by 50%
        sideOffset={4}
      >
        <div className="grid grid-cols-2 gap-y-[10px]">
          {first2Options.map((option) => {
            return renderOptions(option);
          })}
        </div>

        <div className="bg-gray-100 h-[1px] w-full my-[10px]" />

        <p className="text-secondary text-xs leading-[18px] font-medium">
          Templates
        </p>
        <div className="grid grid-cols-2 gap-y-[10px]">
          {remainingOptions.map((option) => {
            return renderOptions(option);
          })}
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
